import React from 'react';
import UserAvatar from 'components/pure/utils/UserAvatar';
import './CoachWithTimeSpent.styl';
import {ProgressCircleAroundContent} from 'charts';

export default class CoachWithTimeSpent extends React.PureComponent {
  render() {
    const {user, fraction} = this.props;
    // Note: progress blends into text avatars a bit. Progress width > 4 makes it pretty obvious. Avoid!
    return (
      <ProgressCircleAroundContent
        baseColor="#ECECEC"
        progressWidth={4}
        fraction={fraction}
        contentSize={30}>
        <UserAvatar
          user={user}
          enableTooltip={true}
          tooltipDirection="top"
          tooltipText={this.renderTooltip()}
        />
      </ProgressCircleAroundContent>
    );
  }

  renderTooltip() {
    const {user, percentage, plans} = this.props;
    return (
      <div className="coach-with-time-spent-tooltip">
        <div className="coach-with-time-spent-tooltip-coach-name">
          <UserAvatar user={user} enableTooltip={false} />
          {user.getFullName()}
        </div>
        <div className="coach-with-time-spent-tooltip-percentage-spent">
          <span>Percentage of the coaching: {percentage}%</span>
        </div>
        <div className="coach-with-time-spent-tooltip-plan-names">
          <ul>
            {plans.map(plan => (
              <li key={plan.id}>
                Coaching Plan: {plan.name} ({plan.completed ? 'Completed' : 'Ongoing'})
              </li>
            ))}
            {this.renderAdHocCalls()}
          </ul>
        </div>
      </div>
    );
  }

  renderAdHocCalls() {
    const {adHocCalls} = this.props;
    if (!adHocCalls) {
      return null;
    }
    const callOrCalls = adHocCalls === 1 ? 'call' : 'calls';
    return (
      <li>
        Ad Hoc Coaching: {adHocCalls} {callOrCalls}
      </li>
    );
  }
}
